import {
  ChangeDetectorRef,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  OnChanges,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

@Directive()
export abstract class WrapperV2ComponentDirective implements OnChanges, OnInit {
  abstract componentName: string;
  @ViewChild('viewChild', { static: true, read: ViewContainerRef })
  viewChild: ViewContainerRef;
  componentRef: ComponentRef<any>;
  componentFactory: ComponentFactory<any>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.setComponent();
    this.passBindings();
  }

  ngOnChanges(): void {
    if (!this.componentRef) {
      return;
    }
    this.passBindings();
    this.invokeChangeDetection();
  }

  // Each feature module has to implement this on their own
  abstract componentMap(): { [key: string]: any };

  // Dynamically chooses which component to load inside the child container based on the componentMap.
  private setComponent(): void {
    const componentMap = this.componentMap();
    this.componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        componentMap[`${this.componentName}`],
      );
    this.viewChild.clear();
    this.componentRef = this.viewChild.createComponent(this.componentFactory);
  }

  private passBindings(): void {
    this.componentFactory.inputs.forEach((input) => {
      // @ts-ignore
      this.componentRef.instance[input.propName] = this[input.propName];
    });

    this.componentFactory.outputs.forEach((output) => {
      // @ts-ignore
      this.componentRef.instance[output.propName] = this[output.propName];
    });
  }

  private invokeChangeDetection(): void {
    this.componentRef.injector
      .get<ChangeDetectorRef>(ChangeDetectorRef as Type<ChangeDetectorRef>)
      .markForCheck();
  }
}
